var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "info" },
    [
      !_vm.isDetail
        ? _c("lb-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns,
              data: _vm.page.list,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "selection-change": _vm.onMultipleSelection,
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
      _vm.isDetail
        ? _c("lb-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
              {
                name: "horizontal-scroll",
                rawName: "v-horizontal-scroll",
                value: "always",
                expression: "'always'",
              },
            ],
            attrs: {
              column: _vm.columns1,
              data: _vm.page1.list,
              pagination: "",
              total: _vm.page1.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page1.currentPage,
              "page-size": _vm.page1.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page1, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page1, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange1,
              "p-current-change": _vm.handleCurrentChange1,
            },
          })
        : _vm._e(),
      _vm.isDetail
        ? _c(
            "div",
            { staticStyle: { display: "flex", "justify-content": "center" } },
            [
              _c("div", { staticClass: "back", on: { click: _vm.back } }, [
                _vm._v("返回"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }